import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full px-4 py-16 md:py-20 bg-slate-900/50" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 border-2 border-green-500 rounded-2xl p-6 md:p-10 text-center" data-id="element-158">
          <ShieldCheckIcon className="w-14 h-14 md:w-16 md:h-16 text-green-400 mx-auto mb-6" data-id="element-159" />
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-160">
            Garantía de Video en 30 Minutos
          </h2>
          <p className="text-base md:text-xl text-gray-200 mb-6" data-id="element-161">
            Si revisas el entrenamiento, usas los prompts y no tienes un video
            listo para publicar en 30 minutos, te devolvemos el 100% dentro de
            los primeros 30 días.
          </p>
          <p className="text-base md:text-lg text-green-300 font-semibold" data-id="element-162">
            Así de confiados estamos en este sistema.
          </p>
        </div>
      </div>
    </section>;
}